import React, {useCallback, useEffect, useMemo} from 'react';
import {useBoxesRemoveIssuesMutation, useGetBoxesQuery} from "@mwServices/Boxes";
import {Modal} from "antd";
import {WarningOutlined} from "@ant-design/icons";
import {showResponse} from "@services/Api";

const useUserBoxes = () => {
    const boxesQuery = useGetBoxesQuery({filters: {}});
    const [callRemoveFromBox, removeFromBoxResponse] = useBoxesRemoveIssuesMutation();

    const boxes = useMemo(() => {
        return boxesQuery.data ? boxesQuery.data.boxes : [];
    }, [boxesQuery.data]);

    const getBoxName = useCallback((boxId: number) => {
        const foundBox = boxes.find((box) => box.id === boxId);
        if(foundBox) return foundBox.name;
        return "na";
    }, [boxes]);

    const removeIssueFromBox = async (boxId: number, collectionItemId: number) => {
        Modal.confirm({
            autoFocusButton: null,
            icon: <WarningOutlined />,
            content: (<div>
                <div><b>Remove Item From Virtual Box</b></div>
                <div style={{paddingTop: 10}}>
                    Are you sure?<br/>
                    Selecting this option will remove this comic from this Virtual Box. The comics will remain in your collection.
                </div>
            </div>),
            onOk: async () => {
                let sanitisedData = {
                    issue_ids: [collectionItemId],
                    box_id: Number(boxId),
                };

                await callRemoveFromBox(sanitisedData);
            },
        });
    };

    useEffect(() => {
        showResponse(removeFromBoxResponse, 'Comic removed from box.', 'Failed to remove comic from box.');
    }, [removeFromBoxResponse]);

    return {
        boxes,
        getBoxName,
        removeIssueFromBox,
    };
}

export default useUserBoxes;